/**
 * NETCORE IMPLEMENTATION
 */

const standardEvents = [
  "Page Browse",
  "Add To Cart",
  "Checkout",
  "Remove From Cart",
  "Product Search",
  "Product View",
  "Lead Submitted",
  "Product Purchase",
  "Add to Wishlist",
  "Remove from Wishlist",
];

const isScriptExists = () => {
  const check = window.smartech && typeof window.smartech === "function";
  // if (check) console.info("[netcoreAdapter] smartech script is found!");
  if (!check) console.warn("[netcoreAdapter] smartech script not found!");

  return check;
};

const hasInstance = () => {
  if (!isScriptExists()) {
    return false;
  }

  // Undocumented method
  return window.smartechclient?.defaultck && window.smartechclient?.defaultsk;
};

const isInstanceExists = (websiteId) => {
  if (!isScriptExists() || !hasInstance()) {
    return false;
  }

  // Undocumented method
  return window.smartechclient?.defaultsk == websiteId;
};

const register = (websiteId) => {
  // window.smartech("create", VITE_NETCORE_SMARTECH_PANEL_ID);
  // window.smartech("register", websiteId);
  console.warn("[netcoreAdapter] register: Skipped! Netcore SDK will be loaded via GTM. Developer don't need to do anything.");
};

const pageViewSingle = (websiteId) => {
  // console.warn("[netcoreAdapter] pageViewSingle: Multi-instance mode is not supported. Falling back to normal mode.");
  pageView();
};

const pageView = () => {
  console.debug("[netcoreAdapter] pageView");
  window.smartech("dispatch", "Page Browse", {});
};

const trackSingle = (websiteId, eventName, eventData = {}) => {
  // console.warn("[netcoreAdapter] trackSingle: Multi-instance mode is not supported. Falling back to normal mode.");
  track(eventName, eventData);
};

const track = (eventName, eventData = {}) => {
  console.debug("[netcoreAdapter] track:", eventName, eventData);
  window.smartech("dispatch", eventName, eventData);
};

const activateDebugMode = () => {
  console.debug("[netcoreAdapter] activateDebugMode");
  window.smartech("debug", "1");
};

const appendUserAttributes = (payload) => {
  console.debug("[netcoreAdapter] appendUserAttributes", payload);

  const pkAttributePrefix = "pk^";
  // const primaryKey = "applicationid";
  const primaryKey = "customerid";
  const lowercaseKeys = ["mobile", "email"]; // netcore require these attributes to be in lowercase property name

  // fix payload upper/lower cases
  const parsedPayload = {};
  Object.entries(payload).forEach(([k, v]) => {
    let newKey = "";
    if (k.toLowerCase() == primaryKey.toLowerCase()) {
      newKey = pkAttributePrefix + k.toLowerCase(); // netcore require PK to be in lowercase
    } else if (lowercaseKeys.map((i) => i.toLowerCase()).includes(k.toLowerCase())) {
      newKey = k.toLowerCase();
    } else {
      newKey = k.toUpperCase(); // netcore require everything else to be in uppercase
    }
    parsedPayload[newKey] = v;
  });

  console.debug("[netcoreAdapter] appendUserAttributes:", parsedPayload);
  window.smartech("contact", "1", {
    ...parsedPayload,
  });
};

const identifyUser = (userUniqueIdentifierValue) => {
  console.info("[netcoreAdapter] identifyUser:", userUniqueIdentifierValue);
  window.smartech("identify", userUniqueIdentifierValue);
};

const clearUser = () => {
  console.debug("[netcoreAdapter] clearUser");
  window.smartech("identify", ""); // no guarantee to work
};

const netcoreAdapter = {
  isScriptExists,
  hasInstance,
  isInstanceExists,
  register,
  pageViewSingle,
  pageView,
  trackSingle,
  track,
  activateDebugMode,
  appendUserAttributes,
  identifyUser,
  clearUser,
};

export default netcoreAdapter;
